import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'
import { lazy, createElement } from 'react'
import {
  useFeatureFlagWithUrlOverride,
  showNonprofitFeed,
} from 'Modules/FeatureFlag'

const HomePage = lazy(() => import('./HomePage/HomePage'))

const NonprofitFeedPage = lazy(
  () => import('./NonprofitFeedPage/NonprofitFeedPage')
)

const DashboardPage = () => {
  const isNewFeed = useFeatureFlagWithUrlOverride(showNonprofitFeed)
  const Component = isNewFeed ? NonprofitFeedPage : HomePage
  return createElement(Component)
}

export default {
  path: '/home',
  exact: true,
  Component: WithPermission(DashboardPage, ['page:home'], true),
  access: 'USER',
}
